import type { RunRequest } from '@/api/runRequests';

/** How often a queued run or session is re-read until the Mac picks it up. */
export const POLL_MS = 4000;

export const isOpen = (r: RunRequest | null) => Boolean(r && !r.finishedAt);
